<nz-tabs
  class="em-tabs-full-width"
  nzType="card"
  (nzSelectedIndexChange)="adobeTrackingSubTabChange($event)"
>
  <nz-tab [nzTitle]="elementDesignTitleTpl">
    <ng-template #elementDesignTitleTpl>
      Element Design
      <i
        *ngIf="elementDesignStructure === undefined"
        class="grey"
        nz-icon
        nzType="exclamation-circle"
        nzTheme="outline"
      ></i>
    </ng-template>
    <nz-skeleton
      [nzActive]="true"
      [nzLoading]="(elementDesignTabLoading$ | async) ?? false"
      [nzParagraph]="{ rows: 5 }"
    >
      <em-teamcenter-tab-header
        *ngIf="elementDesignStructure"
        [content]="elementDesignStructure"
      ></em-teamcenter-tab-header>

      <em-ed-revision-structure
        [error]="(edError$ | async) ?? ''"
        [elementDesignStructure]="elementDesignStructure"
      ></em-ed-revision-structure>

      <nz-result
        *ngIf="elementDesignStructure === undefined"
        nzTitle="Sorry, nothing to see here..."
      ></nz-result>
    </nz-skeleton>
  </nz-tab>

  <nz-tab [nzTitle]="mouldCavityTitleTpl">
    <ng-template #mouldCavityTitleTpl>
      Mould Cavity
      <i
        *ngIf="mouldCavityStructure === undefined"
        class="grey"
        nz-icon
        nzType="exclamation-circle"
        nzTheme="outline"
      ></i>
    </ng-template>
    <nz-skeleton
      [nzActive]="true"
      [nzLoading]="(mouldCavityTabLoading$ | async) ?? false"
      [nzParagraph]="{ rows: 5 }"
    >
      <em-teamcenter-tab-header
        *ngIf="mouldCavityStructure"
        [content]="mouldCavityStructure"
      ></em-teamcenter-tab-header>

      <em-item-structure
        [itemStructure]="mouldCavityStructure"
        [error]="(mdError$ | async) ?? ''"
      ></em-item-structure>

      <nz-result
        *ngIf="mouldCavityStructure === undefined"
        nzTitle="Sorry, nothing to see here..."
      ></nz-result>
    </nz-skeleton>
  </nz-tab>

  <nz-tab [nzTitle]="mouldDesignTitleTpl">
    <ng-template #mouldDesignTitleTpl>
      Mould Design
      <i
        *ngIf="mouldDesignStructure === undefined"
        class="grey"
        nz-icon
        nzType="exclamation-circle"
        nzTheme="outline"
      ></i>
    </ng-template>
    <nz-skeleton
      [nzActive]="true"
      [nzLoading]="(mouldDesignTabLoading$ | async) ?? false"
      [nzParagraph]="{ rows: 5 }"
    >
      <em-teamcenter-tab-header
        *ngIf="mouldDesignStructure"
        [content]="mouldDesignStructure"
      ></em-teamcenter-tab-header>

      <em-item-structure
        [itemStructure]="mouldDesignStructure"
        [error]="(mdError$ | async) ?? ''"
      ></em-item-structure>

      <nz-result
        *ngIf="mouldDesignStructure === undefined"
        nzTitle="Sorry, nothing to see here..."
      ></nz-result>
    </nz-skeleton>
  </nz-tab>

  <nz-tab [nzTitle]="partDesignTitleTpl">
    <ng-template #partDesignTitleTpl>
      Part Design
      <i
        *ngIf="partDesignStructure === undefined"
        class="grey"
        nz-icon
        nzType="exclamation-circle"
        nzTheme="outline"
      ></i>
    </ng-template>
    <nz-skeleton
      [nzActive]="true"
      [nzLoading]="(partDesignTabLoading$ | async) ?? false"
      [nzParagraph]="{ rows: 5 }"
    >
      <em-teamcenter-tab-header
        *ngIf="partDesignStructure"
        [content]="partDesignStructure"
      ></em-teamcenter-tab-header>

      <em-part-design-revision-structure
        [error]="(pdError$ | async) ?? ''"
        [partDesignStructure]="partDesignStructure"
      ></em-part-design-revision-structure>

      <nz-divider *ngIf="partDesignStructure"></nz-divider>

      <nz-collapse *ngIf="partDesignStructure">
        <nz-collapse-panel nzHeader="Appendix">
          <em-related-specification-structure
            class="em-area"
            [error]="(pdError$ | async) ?? ''"
            [relatedSpecification]="(relatedSpecifications$ | async) ?? []"
          ></em-related-specification-structure>
        </nz-collapse-panel>
      </nz-collapse>

      <nz-result
        *ngIf="partDesignStructure === undefined"
        nzTitle="Sorry, nothing to see here..."
      ></nz-result>
    </nz-skeleton>
  </nz-tab>
</nz-tabs>
